import { Helmet } from "react-helmet-async";

export type CanonicalProps = {
  path: string;
};

export default function CanonicalLink({ path }: CanonicalProps) {
  return (
    <Helmet>
      <link href={`${import.meta.env.VITE_BASE_URL}${path}`} rel="canonical" />
      <meta content={`${import.meta.env.VITE_BASE_URL}${path}`} property="og:url" />
    </Helmet>
  );
}
